const e = {
  "cdr-image": "cdr-image_15-0-1"
};
export {
  e as default
};
